module.exports = __webpack_public_path__ + "img/hontai_MidnightGray.ffb014e0.png";